import { render, staticRenderFns } from "./SelectWithGroupedOptions.vue?vue&type=template&id=ece4ca22&scoped=true"
import script from "./SelectWithGroupedOptions.vue?vue&type=script&lang=ts"
export * from "./SelectWithGroupedOptions.vue?vue&type=script&lang=ts"
import style0 from "./SelectWithGroupedOptions.vue?vue&type=style&index=0&id=ece4ca22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece4ca22",
  null
  
)

export default component.exports